import { CapiImage } from '../components/Image/Image';

export const isVilma = (url: string) => {
  return url.match(/vilma/i);
};

export const filterImagesByRel = (
  images: CapiImage[] | undefined,
  keys: string[]
): CapiImage[] => {
  return (
    images?.filter(
      (image: CapiImage, i: number) => image.rel && keys.includes(image.rel)
    ) || []
  );
};

export const filterImageByRel = (
  images: CapiImage[] | undefined,
  keys: string
) => filterImagesByRel(images, [keys])[0];

//Replaces the value for width in the url of an image e.g. 512.png to 1024.png
export const updateImageResolution = (uri: string, width?: string) => {
  if (isVilma(uri)) {
    return uri;
  } else if (width) {
    const uriParts = uri.split('/');
    const lastUriPart = uriParts[uriParts.length - 1];

    uriParts[uriParts.length - 1] = lastUriPart.replace(
      /^[\d]*\./,
      `${width}.`
    );

    return uriParts.join('/');
  }

  return uri;
};
